import { Fragment, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { IconButton, WithTooltip } from 'basic-components';
import { Add, Replace } from 'basic-components/icons';
import { globalActions } from 'primary-components';

import FORMULAS from 'resources/constants/Formulas.js';
import { ExcelUtils, GAUtils } from 'utils';

import './Actions.scss';

const Actions = ({ name, groupName }) => {
  const dispatch = useDispatch(),
        address = useSelector(state => state.datalakeState.address),
        defaultSource = useSelector(state => state.globalState.localSource),
        add = useCallback(() => {
          GAUtils.sendEvent({
            category: "action",
            action: "add_file",
            label: "add"
          })
          if(!name) {
            dispatch(globalActions.getMessageStore()).error("File does not exist")
            return
          }
          ExcelUtils.addToFormulaCell({ address, formula: `=${FORMULAS.LOAD_FILE}("${name}","${groupName}", "${defaultSource}")` })
        }, [address, defaultSource, dispatch, groupName, name]),
        handleOnKeyDown = useCallback(e => {
          if ((e.key === "Enter" || e.key === " ")) {
            e.preventDefault()
            add()
          }
        }, [add])
        
  return (
    <Fragment>
      <WithTooltip
          data-place="top"
          short
          text={address ? "Replace" : "Add"}
      >
        <IconButton
            aria-label={`Add to sheet ${name} ${groupName}`}
            className="ng-office-app__authed__content__body__item__body__scroll__row__action ng-office-app__authed__content__body__item__body__scroll__row__action--add"
            onClick={add}
            onKeyDown={handleOnKeyDown}
            tabIndex={0}
        >
          {!address ? (<Add/>) : (<Replace/>)}
        </IconButton>
      </WithTooltip>
    </Fragment>
  )
}

Actions.propTypes = {
  groupName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default memo(Actions);